import React, {Component} from 'react';
import _ from 'lodash';
import { Button, Segment, Form, Modal, Image, Icon, Dropdown, Checkbox, Confirm, Popup} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { getConst} from '../../core/consts';
import accounting from 'accounting';
import {applyCard} from '../../core/apiClient';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { applySuccess, storeSimulateEmail, storeApplyFormInput } from '../../redux/actions';
import $ from 'jquery';
import {getStaticText} from '../../core/lang';
import {nationality} from './../applyForm/nationality.js';


export class CardCompare extends Component {
  constructor() {
    super();
    this.state = {
      applyMessage: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailId: '',
      salary: 5000,
      terms: false,
      phoneNumberCode: '050',
      selfEmployed:false,
      openApplyResponsePopup: false,
      goodTimeToCall: '',
      nationality: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary: '',
        nationality: '',
      },
      autoLoanApplied: false,
      onFocus: '',
      openConfirmPopup: false,
      showContractAlert: false,
      cardsLength: 0,
    }
  }

  show = () => this.setState({ openApplyResponsePopup: true })
  close = () => this.setState({ openApplyResponsePopup: false })

  showConfirm = () => this.setState({ openConfirmPopup: true })
  handleConfirm = () => {
    this.setState({ openConfirmPopup: false });
    this.props.data.closeApplyFormInCompare();
  }
  handleCancel = () => this.setState({ openConfirmPopup: false })

  finalCardApply = (utmSource,utmMedium,utmCampaign) => {
    if(utmCampaign===null){
      utmCampaign = 'Nil';
    }
    else{
      utmCampaign = sessionStorage.getItem("utm_campaign")
    }

    if(utmMedium===null){
      utmMedium = 'Nil';
    }
    else{
      utmMedium = sessionStorage.getItem("utm_medium")
    }

    if(utmSource===null){
      utmSource = 'Nil';
    }
    else{
      utmSource = sessionStorage.getItem("utm_source")
    }
    
    let referrer = document.referrer;
    if(referrer===''|| _.isEmpty(referrer)){
      referrer = window.location.href;
    }
    

    const validFirstName = this.handleFirstNameBlur(), validLastName = this.handleLastNameBlur(),
    validEmail = this.handleEmailIdBlur(), validPhone = this.handlePhoneNumberBlur(),
    validTerms = this.handleTermsValidate(), salary = this.handleSalaryBlur();
    if (validFirstName && validLastName && validEmail && validPhone && validTerms && salary) {
      let productIds = [];
      _.forEach(this.props.data.applyCards, (card) => {
        productIds.push(card.id)
      });
      let email = this.state.emailId;
      let selfEmployedVal = 'false';
        if(this.state.selfEmployed===true){
          selfEmployedVal = this.state.selfEmployed.toString();
        }
        let goodTimeToCall = 'N/A'
        if(this.state.goodTimeToCall !== ''){
          goodTimeToCall = this.state.goodTimeToCall;
        }
      applyCard({
        'customer': {
          'first_name': this.state.firstName,
          'email': email,
          'last_name': this.state.lastName,
          'phone': `+971${this.state.phoneNumberCode}${this.state.phoneNumber}`,
          'salary': this.state.salary,
          'goodTimeToCall': goodTimeToCall,
          'selfEmployed': selfEmployedVal,
          'nationality': this.state.nationality,
          "utm_tracking_details": {
            "utm_source": utmSource,
            "utm_medium": utmMedium,
            "utm_campaign": utmCampaign,
            "request_url": window.location.href,
            "http_referrer": referrer
            }
        },
        'productIds': productIds
      }
      ).then((response) => {
        this.setState({
          autoLoanApplied: true
        });
        this.props.storeSimulateEmail(email, false);
        this.props.storeApplyFormInput({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          phoneNumber: this.state.phoneNumber,
          emailId: email,
          salary: this.state.salary,
          nationality: this.state.nationality,
          selfEmployed: selfEmployedVal
        });
        this.closeAllApplyPopup();
      }).catch((err) =>{
          this.props.storeSimulateEmail(email, false);
          this.props.storeApplyFormInput({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: this.state.phoneNumber,
            emailId: email,
            salary: this.state.salary,
            nationality: this.state.nationality,
            selfEmployed: selfEmployedVal,
            //incomeType: this.state.incomeType

          });
          this.closeAllApplyPopup();
          //this.props.history.push("/credit-cards");
          const {multiple_apply_error} = getStaticText(this.props.activeLanguage);
          this.props.applySuccess(`${multiple_apply_error}`, true);
           })
    }
  }

  handleTerms = (e, {checked}) => {
    this.setState({terms: checked})
  }

  handleTermsValidate = () => {
    let valid = false;
    const {accept_terms_message} = getStaticText(this.props.activeLanguage);
    if (!this.state.terms) {
      this.createError('terms', accept_terms_message);
    } else {
      this.createError('terms', '');
      valid = true;
    }
    return valid;
  }

  handleFirstNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.firstName)) {
      this.createError('firstName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.firstName)) {
      this.createError('firstName', info_required_msg);
    } else {
      this.createError('firstName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleLastNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.lastName)) {
      this.createError('lastName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.lastName)) {
      this.createError('lastName', info_required_msg);
    } else {
      this.createError('lastName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleEmailIdBlur = () => {
    let email = this.state.emailId;
    let valid = false;
    const {email_id_required_msg, email_id_valid_msg} = getStaticText(this.props.activeLanguage);
    const {emailRegex} = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError('emailId', email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError('emailId', email_id_valid_msg);
    } else {
      this.createError('emailId', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handlePhoneNumberBlur = () => {
    let valid = false;
    const {phone_number_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.phoneNumber) || this.state.phoneNumber.length !== 7) {
      this.createError('phoneNumber', phone_number_valid_msg);
    } else {
      this.createError('phoneNumber', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleSalaryBlur = () => {
    let valid = false;
    const {please_input_salary,please_input_min_salary} = getStaticText(this.props.activeLanguage);
    if (this.state.salary < 1 || this.state.salary === undefined) {
      this.createError('salary', please_input_salary);
    }else if(this.state.salary < 0){
      this.createError('salary', please_input_min_salary);
    } else {
      this.createError('salary', '');
      valid = true
    }
    return valid;
  }
  handleNationalityBlur = () => {
    let valid = false;
    const {nationality_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.nationality)) {
      this.createError('nationality', nationality_valid_msg);
    } else {
      this.createError('nationality', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }
  createError = (field, error) => {
    const errors = _.assign(this.state.errors, {[field]: error})
    this.setState({
      errors
    })
  }

  handleInputChange = (e, {value, name}) => {
    const {telephone} = getConst(this.props.activeLanguage);
    if(name === 'emailId'){
      value = value.trim();
    }
    if (name === 'phoneNumber') {
      if (telephone.test(value)) {
        this.setState({
          [name]: value
        })
      }
    } else {
      if(name === 'firstName' || name === 'lastName'){
        value = value.toUpperCase();
      }
      this.setState({
        [name]: value
      })
    }
  }
  handlePhoneNumberCode = (e, {value}) => {
    this.setState({phoneNumberCode: value})
  }

  closeAllApplyPopup = () => {
    const {applying_auto_loan_with_us} = getStaticText(this.props.activeLanguage);
    this.props.applySuccess(`${applying_auto_loan_with_us}`, true);
    this.props.history.push(`/thank-you-page/${this.props.data.applyCards[0].name}/${this.props.data.applyCards[0].id}`);
    this.setState({
      terms: false,
      goodTimeToCall: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary: '',
        nationality:'',
      }
    });
    this.close();
    this.props.data.comparePopupClose();
  }

  handleSelfEmployed = (e, {checked}) => {
    console.log("Emp:",checked);
      this.setState({selfEmployed: checked})
   }

  handleTimeToCall = (e, {value}) => {
    this.setState({goodTimeToCall: value});
  }

  handleNationality = (e, {value}) => {
    this.setState({nationality: value});
    this.createError('nationality', '');
  }

  handleContractAlert = () => {
    if($(window).width() < 768) {
      this.setState({
        showContractAlert: !this.state.showContractAlert
      })
    }
    $('.apply-content-compare').animate({
      scrollTop: 0
    }, 300)
  }

  handleMonthlySalaryChange = (value) => (this.setState({salary:value}));
  componentWillMount() {
  }

  handleSalaryInputChange = (e, {value, max}) => {
    const formatedValue = accounting.unformat(value)
    let validValue = formatedValue;
    if (max < formatedValue) {
      validValue = max;
    }
    this.setState({ salary: _.toNumber(validValue) })
  }

  onFocusField = (name) => {
    this.setState({onFocus: name})
  }

  fixBody() {
    const anotherModal = document.getElementsByClassName('ui page modals').length;
    if (anotherModal > 0) document.body.classList.add('scrolling', 'dimmable', 'dimmed');
  }

  digitValidate = (e) => {
    const re = /^[0-9.]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data.compareCards !== this.props.data.compareCards){
      if(nextProps.data.applyFlag){
        nextProps.data.closeApplyFormInCompare();
      }
    }
    if(nextProps.data.applyCards.length !== this.props.data.applyCards.length ){
      if(!nextProps.data.applyCards.length >  0){
        nextProps.data.closeApplyFormInCompare();
      }
    }
    if (!_.isEqual(this.props.data, nextProps.data) && nextProps.data.popupOpen) {
      this.setState({
        errors: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailId: '',
          terms: '',
          salary: '',
        },
        terms: false,
      });
      this.setState({
        firstName: this.props.applyInputForm.firstName,
        lastName: this.props.applyInputForm.lastName,
        phoneNumber: this.props.applyInputForm.phoneNumber,
        emailId: this.props.applyInputForm.emailId,
        salary: this.props.applyInputForm.salary,
      });
    }
    if(nextProps.data.popupOpen ) {
      this.setState({
        cardsLength: nextProps.data.cardDetailsLength
      })
    }
  }

  render() {
    var hiddenFields = document.querySelectorAll("input[type=hidden], input[type=text]");
    //alert("Lenght:", hiddenFields.length);
    for (var i=0; i<hiddenFields.length; i++) {
      var utmParam = sessionStorage.getItem(hiddenFields[i].name);
          var utmCampaign = sessionStorage.getItem("utm_campaign");
          
          var utmMedium = sessionStorage.getItem("utm_medium");
          
          var  utmSource = sessionStorage.getItem("utm_source");
          
          //document.getElementById("utm-source-hidden-field").value = 'hi';

          if (utmParam) {
            document.getElementsByName("utm_campaign")[0].value = utmCampaign;
            document.getElementsByName("utm_medium")[0].value = utmMedium;
            document.getElementsByName("utm_source")[0].value = utmSource;
          }    
    }

    const lang = getStaticText(this.props.activeLanguage);
    const {phoneNumberCode} = getConst(this.props.activeLanguage);
    //if (this.state.autoLoanApplied) {
    //  return <Redirect to='/credit-cards'/>;
    //}
    
    let blankPlaceArray = [];
    let blankPlaceLength = 0;
    if(this.state.cardsLength<4) {
      blankPlaceLength = this.state.cardsLength - this.props.data.compareCards.length;
    } else {
      blankPlaceLength = 4 - this.props.data.compareCards.length;
    }

    if(blankPlaceLength<=4) {
      for (var i=1; i<= blankPlaceLength; i++) {
        blankPlaceArray.push(i);
      }
    }
    
    return (
      <Modal className='modal-compare modal-compare--loans' open={this.props.data.popupOpen} onClose={this.props.data.comparePopupClose} closeOnEscape={false} closeOnRootNodeClick={false} closeIcon={false}>
                  <img src="https://soulwallet.imgix.net/static-compressed/assets/home/close-new.png?auto=compress&fm=webp%7Cauto=compress"
                  alt="" 
                  className="applynow-application-close-icon compare-cl-icon" onClick={this.props.data.comparePopupClose}/>

        <Modal.Header>
          {/* <img className='img-responsive show-for-desktop' alt={lang.soul_wallet} src='https://soulwallet.imgix.net/static-compressed/sw_logo-w.png?auto=compress' />
          <img className="img-responsive show-for-small" alt={lang.soul_wallet} src='https://soulwallet.imgix.net/static-compressed/sw_logo-small.png?auto=compress' /> */}
          <h3 className='modal-title compare-model'>{lang.compare} {lang.auto_loans} ({this.props.data.compareCards.length})</h3>

        </Modal.Header>
        <Modal.Content>
          <div className='modal-content'>
            <div className={_.isEmpty(this.props.data.applyCards)?'modal-content-top model-button-pos':'modal-content-top modal-content-top--applied model-button-pos'}>
              <div className={!_.isEmpty(this.props.data.applyCards)?'modal-content-head disabled':'modal-content-head'}></div>
              {this.props.data.compareCards.map((row, idx) => (
                <div key={idx} data-id={idx} className={!_.isEmpty(this.props.data.applyCards) && _.has(this.props.data.applyCardChecked, row.id) && this.props.data.applyCardChecked[row.id]?'modal-content-img selected':'modal-content-img'}>
                  <Button className='modal-close' icon='remove' value={row.id} onClick={this.props.data.removeCompareCard}></Button>
                  <Image alt={row.bankName+" "+row.name} className='img-responsive' src={row.logo} />
                    <h3 className='bank-name'>{row.bankName}</h3>
                    {/* <h4 className='card-name'>{row.name}</h4> */}
                    <Dropdown
                      fluid search selection
                      options={this.props.data.cardObjectForSearch}
                      icon='search'
                      onChange={this.props.data.onCompareCardSearchChange}
                      preid={row.id}
                      text={row.name}
                      selectOnBlur={false}
                    />
                    <div className='cta' onClick={this.handleContractAlert} title={row.contract? lang.apply_now: lang.non_contract_alert_less}>
                      {/* <Checkbox className='checkbox show-for-desktop' disabled={!row.contract} label='' value={row.id} onChange={(e, obj)=>{this.props.data.handleMultipleApplyCard(e,{value:obj.value, checked:obj.checked});this.props.data.applyCreditCard(e,{value:obj.value});}} checked={_.has(this.props.data.applyCardChecked, row.id) && this.props.data.applyCardChecked[row.id]} /> */}
                      <Button className={row.contract?'btn btn-blue btn-apply show-for-desktop':'btn btn-blue btn-apply show-for-desktop disabled'} value={row.id} onClick={this.props.data.handleMultipleApplyCard} checked={true}>{lang.apply}</Button>
                        <Button className={row.contract?'btn btn-blue show-for-small':'btn btn-blue show-for-small disabled'} cardid={row.id} onClick={this.props.data.applyDirect}>{lang.apply}</Button>
                    </div>
                    {this.state.showContractAlert? <div className='small-modal pop-close'>
                      <div className='small-modal-body'>
                        <a className='small-modal-icon' onClick={this.handleContractAlert} href='javascript:;' title='Close'><i className='close icon' /></a>
                        <div className='small-modal-content'>
                          {lang.non_contract_alert_less}
                        </div>
                      </div>
                    </div>:'' }
                </div>
              ))}
              {
                blankPlaceArray.map((row, idx) => (
                  <div className='modal-content-img' key={idx}>
                    <Dropdown
                      style={{color:'#9a9fa2'}}
                      fluid search selection
                      options={this.props.data.cardObjectForSearch}
                      icon='search'
                      onChange={this.props.data.onCompareCardSearchChange}
                      preid={row.id}
                      text='Select Loan'
                      className='dropdown-select'
                      selectOnBlur={false}
                    />
                  </div>
                ))
              }
            </div>
          {_.isEmpty(this.props.data.applyCards)?
            <div className='modal-content-center'>
            <ul className='content-list list-modal-rating'>
                <li></li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx} className="compare-modal-rating">
                    {/* <div className='modal-rating'>
                      <Rating icon='star' defaultRating={row.rating} maxRating={5} disabled /><span className='rating-count'>({row.numberOfReviews})</span>
                    </div> */}
                    <Button basic tabIndex={row.id} onClick={this.props.data.toggleVisibilityForPdp} className='reset-styles' style={{width: '100%'}}>
                      <span className='cta-link color-blue bold' >{lang.learn_more}</span>
                    </Button>
                  </li>
                ))}
              </ul>
              <ul className='content-list text-left flex'>
                <li className="big-label relative">
                  <span className='v__align'>{lang.top_reason_to_choose}</span>
                  </li>
                  {this.props.data.compareCards.map((row, idx) => (
                    <li key={idx}>
                    <span className='label-mobile width-200'>{lang.top_reason_to_choose}</span>
                      <ul className='list-check'>
                      {_.isEmpty(row.topReasons)?<span />:
                        row.topReasons.map((item, idx) => (
                          <li key={idx}>
                            <span>{_.upperFirst(item)}</span>
                          </li>
                      ))}
                      </ul>
                    </li>
                  ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.minimum_salary_required}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.minimum_salary_required}</span>{accounting.formatMoney(row.minimumSalary, `${lang.aed} `, 0)}
                  </li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.fixed_interest_rate}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.fixed_interest_rate}</span>{row.fixedRate.toFixed(2)} %</li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.reducing_interest_rate}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.reducing_interest_rate}</span>{row.reducingRate.toFixed(2)} %</li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.max_loan_amount}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.loan_amount}</span>{accounting.formatMoney(row.maxLoanAmount, `${lang.aed} `, 0)}</li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.down_payment}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.down_payment}</span>{row.downPayment.toFixed(2)} %</li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.processing_fee}</span>
                  </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.processing_fee}</span>{row.processingFee}</li>
                ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.emi} ({lang.monthly})</span>
                  </li>
                {this.props.appliedEmi?this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}><span className='label-mobile width-200'>{lang.emi} ({lang.monthly})</span><span>{_.has(row, 'emi')? `${accounting.formatMoney(row.emi, `${lang.aed} `, 0)}`:`${lang.na}`}</span>
                  <p>({_.has(row, 'autoLoanAmount')? `For ${accounting.formatMoney(row.autoLoanAmount, `${lang.aed} `, 0)}`:`${lang.na}`})</p></li>
                )):
                <li className='content-list-simulator'>
                <Button basic onClick={this.props.data.comparePopupClose} className='reset-styles'>
                  <Link className='cta-link color-blue bold' to={{ pathname: '/car-loans', query: { simulateEmi: true } }}>{lang.use_auto_loan_emi_link}</Link>
                  {/* <a className='cta-link color-blue bold margin-left-full' href="javascript:;">Please use the Simulate Your Loan EMI to get your Monthly (EMI) option for Comparison</a> */}
                </Button>
                </li>
                }
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.joining_offer}</span>
                  </li>
                  {this.props.data.compareCards.map((row, idx) => (
                    <li key={idx}>
                    <span className='label-mobile width-200'>{lang.joining_offer}</span>
                    {row.joiningOffers?
                        <span>
                            <div className='card-descp' dangerouslySetInnerHTML={{__html:_.upperFirst(row.joiningOffers) }}></div>
                        </span>:
                        <span>
                          <Icon name='minus' className='color-gray' />
                        </span>
                      }
                    </li>
                  ))}
              </ul>
              <ul className='content-list flex'>
                <li className='relative'>
                  <span className='v__align'>{lang.used_car_finance}</span>
                  </li>
                  {this.props.data.compareCards.map((row, idx) => (
                    <li key={idx}>
                    <span className='label-mobile width-200'>{lang.used_car_finance}</span>
                      {_.toLower(row.usedCarFinance) === 'yes'?
                            <span>
                              <Icon name='checkmark' />
                            </span>:
                            <span>
                              <Icon name='minus' className='color-gray' />
                            </span>
                          }
                    </li>
                  ))}
              </ul>
              <ul className='content-list text-left flex'>
                <li className="big-label relative">
                  <span className='v__align'>{lang.things_to_aware}</span>
                  </li>
                  {this.props.data.compareCards.map((row, idx) => (
                    <li key={idx}>
                    <span className='label-mobile width-200'>{lang.things_to_aware}</span>
                      {
                        _.isEmpty(row.thingsToAware.filter(Boolean))?
                        <span>
                          <Icon name='minus' className='color-gray' />
                        </span>
                        :
                        <ul className='quick-view-list list'>
                        {row.thingsToAware.map((item, idx) => (
                          <li key={idx}>{_.upperFirst(item)}</li>
                        ))}
                        </ul>
                      }
                    </li>
                  ))}
              </ul>
              <ul className='content-list flex'>
              <li className='relative'>
                <span className='v__align'>{lang.conditional_offer}</span>
                </li>
                {this.props.data.compareCards.map((row, idx) => (
                  <li key={idx}>
                    <span className='label-mobile width-200'>{lang.conditional_offer}</span>
                    {!_.isEmpty(row.conditionalOffers.filter(Boolean))?
                    <span>
                      <Icon name='checkmark' />
                    </span>:
                    <span>
                      <Icon name='minus' className='color-gray' />
                    </span>
                    }
                  </li>
                ))}
            </ul>
            </div>:
            <div className='modal-content apply-content apply-content-compare'>
            <Segment.Group horizontal>
              <Segment.Group className='compare-card--loans'>
                
                  <h3 className='card-name'>{lang.apply_auto_loan_for_this_bank}</h3>
                  <p>{lang.auto_loan_compare_apply_description}</p>
               
                {_.isEmpty(this.props.data.applyCards)?'':this.props.data.applyCards.map((row, idx) => (
                  <Segment key={idx}>
                    <h3 className='bank-name'>{row.bankName}</h3>
                    <h3 className='card-name'>{row.name}</h3>
                    <p className='amount-list'><span className='label'>{lang.minimum_monthly_salary} </span> <span className='value'>{accounting.formatMoney(row.minimumSalary, `${lang.aed} `, 0)}</span></p>
                    <p className='amount-list'><span className='label'>{lang.fixed_rate}</span> <span className='value'>{row.fixedRate.toFixed(2)}%</span></p>
                    <p className='amount-list'><span className='label'>{lang.reducing_rate}</span> <span className='value'>{row.reducingRate.toFixed(2)}%</span></p>
                    {_.has(row, 'emi')?
                      <p className='amount-list'><span className='label'>{lang.emi}</span> <span className='value'>{accounting.formatMoney(row.emi, `${lang.aed} `, 0)}</span></p>:
                      ''
                    }
                    <p className='amount-list'><span className='label'>{lang.loan_amount}</span> <span className='value'>{accounting.formatMoney(row.maxLoanAmount, `${lang.aed} `, 0)}</span></p>
                    <p className='amount-list'><span className='label'>{lang.down_payment} </span> <span className='value'>{row.downPayment.toFixed(2)}%</span></p>
                  </Segment>
                ))}
              </Segment.Group>
              <Segment className='compare-card--apply apply-now-detail'>
                <h3 className='modal-content-title text-center'>{lang.apply_online}</h3>
                <Form className='custom-form show-for-desktop' id='apply-form'>
                  <div className='form-control'>
                  <span className={!_.isEmpty(this.state.firstName) || this.state.onFocus === 'firstName'?'label-animate active': 'label-animate'}>{lang.first_name} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.firstName}
                      onBlur={this.handleFirstNameBlur}
                      name='firstName'
                      onChange={this.handleInputChange}
                      onFocus={(value) => this.onFocusField('firstName')}
                      maxLength={30}
                    />
                    <span className='input-error'>{this.state.errors.firstName}</span>
                  </div>
                  <div className='form-control'>
                  <span className={!_.isEmpty(this.state.lastName) || this.state.onFocus === 'lastName'?'label-animate active':'label-animate'}>{lang.last_name} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.lastName}
                      onBlur={this.handleLastNameBlur}
                      name='lastName'
                      onChange={this.handleInputChange}
                      onFocus={(value) => this.onFocusField('lastName')}
                      maxLength={30}
                    />
                    <span className='input-error'>{this.state.errors.lastName}</span>
                  </div>
                  <div className='form-control'>
                    <span className={!_.isEmpty(this.state.emailId) || this.state.onFocus === 'emailId'?'label-animate active':'label-animate'}>{lang.email_id} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.emailId}
                      onBlur={this.handleEmailIdBlur}
                      name='emailId'
                      onChange={this.handleInputChange}
                      maxLength={50}
                      onFocus={(value) => this.onFocusField('emailId')}
                    />
                    <span className='input-error'>{this.state.errors.emailId}</span>
                  </div>
                  <div className='form-control'>
                  
                    <div className='phone-number-wrap'>
                      <span>+971</span>
                      <div className='label'>
                      <Dropdown
                          value={this.state.phoneNumberCode}
                          selection
                          options={phoneNumberCode}
                          onChange={this.handlePhoneNumberCode}
                          search={false}
                        />
                      </div>
                      <div className='field-phone-number'>
                      <Form.Input
                          value={this.state.phoneNumber}
                          placeholder={`${lang.ex}: 8787877`}
                          onBlur={this.handlePhoneNumberBlur}
                          name='phoneNumber'
                          type='tel'
                          onChange={this.handleInputChange}
                          maxLength={7}
                          onFocus={(value) => this.onFocusField('phoneNumber')}
                          onKeyPress={this.digitValidate}
                        />
                      </div>
                    </div>
                    <span className='input-error'>{this.state.errors.phoneNumber}</span>
                  </div>
                  {/* <div className='form-control direct-apply--opt choose-time apply-opt-compare'>
                    <p>{lang.good_time_to_call}</p>
                    <Dropdown
                      value={this.state.goodTimeToCall}
                      selection
                      options={goodTimeToCall}
                      onChange={this.handleTimeToCall}
                      search={false}
                      placeholder={lang.select}
                      id='goodtime'
                    />
                  </div> */}
                  <div className='form-control choose-time direct-apply--opt-nat apply-opt-compare'>
                    <p>Nationality*</p>
                    <Dropdown
                      value={this.state.nationality}
                      selection
                      options={nationality}
                      onChange={this.handleNationality}
                      search={true}
                      id='goodtime'
                      placeholder={lang.select}

                    />
                     <span className='input-error'>{this.state.errors.nationality}</span>
                  </div>
                  <div className='form-control direct-apply--salary good-call'>
                    <span>{lang.monthly_salary}<span className='asterik'>*</span></span>
                    <Slider
                      step={this.state.salary < ((60/100)*200000) ? 500
                       :
                       (this.state.salary >= ((60/100)*200000)) ?  2000
                       :
                       2000}
                      value={this.state.salary}
                      min={0}
                      max={200000}
                      onChange={this.handleMonthlySalaryChange}
                      className='rc-slider--yellow'
                      tabIndex={-1}
                    />
                    <Form.Input
                      onChange={this.handleSalaryInputChange}
                      value={this.state.salary>0?`${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)}`:''}
                      max={200000}
                     // placeholder={`${lang.max}: 200,000`}
                      placeholder={lang.aed_5000}
                      type='text'
                      onBlur={this.handleSalaryBlur}
                      className='has-price-format margin-btm-0'
                      onKeyPress={this.digitValidate}
                    />
                    <span className='input-error'>{this.state.errors.salary}</span>
                  </div>
                  {/* <div className='form-control choose-time direct-apply--opt-nat apply-opt-compare'>
                    <p>Income Type*</p>
                    <Dropdown
                      value={this.state.selfEmployed}
                      selection
                      options={incomeType}
                      onChange={this.handleSelfEmployed}
                      id='goodtime'
                      // placeholder={lang.select}
                    />
                     <span className='input-error'>{this.state.errors.incomeType}</span>
                  </div> */}
                  <input type="hidden" id="utm-source-hidden-field" name="utm_source" value={utmSource===null?'Nil':utmSource} />
                  <input type="hidden" id="utm-medium-hidden-field" name="utm_medium" value={utmMedium===null?'Nil':utmMedium} />
                  <input type="hidden" id="utm-campaign-hidden-field" name="utm_campaign" value={utmCampaign===null?'Nil':utmCampaign}/>
                  <div className='self-em form-control '>
                  <Checkbox required label='' onClick={this.handleSelfEmployed} checked={this.state.selfEmployed} className='display-inline-block left unasterik'></Checkbox>
                  <label className='width-90 display-inline-block margin-left-10 self_emp_label_compare'>{lang.self_em}</label>
                </div>
                  <div className='form-control padding-top-0 direct-apply--terms apply-teams'>
                    <Form.Checkbox checked={this.state.terms} onClick={this.handleTerms} required label='' className='display-inline-block left unasterik'></Form.Checkbox>
                    <label className='width-90 display-inline-block margin-left-10'>
                      {lang.apply_terms} I confirm that I have read and agree to Soulwallet Portal LLC’s <a href='/terms-and-conditions' target="_blank">Terms</a> and <a href='/privacy-policy' target="_blank"> Privacy Policy</a>.
                      {this.props.data.applyCards.filter(card => card.bankName === 'Citi').length? 
                        <p>{lang.citi_new_disclaimer}
                        <Popup
                            trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                            content={lang.citi_popup}
                            size='tiny'
                            wide='very'
                            position='left center'
                            basic
                            on='click'
                        />
                        </p>:''
                      }
                    </label>
                    <span className='input-error'>{this.state.errors.terms}</span>
                  </div>
                </Form>
              </Segment>
            </Segment.Group>
              <div className='modal-footer'>
              <Button className='btn btn-white' type='reset' onClick={this.props.data.comparePopupClose}>{lang.cancel}</Button>
              <Button className='btn btn-blue right' id='submit-application' onClick={()=>this.finalCardApply(utmSource,utmMedium,utmCampaign)}>{lang.submit}</Button>
              </div>
            </div>
          }
          <Modal open={this.state.openApplyResponsePopup} size='mini' onClose={this.close}>
            <Modal.Header>
              {lang.apply_loan_response}
            </Modal.Header>
            <Modal.Content>
              <p>{this.state.applyMessage}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button positive onClick={this.closeAllApplyPopup} icon='checkmark' content={lang.view_more} />
            </Modal.Actions>
          </Modal>
          </div>
          <div>
            <Confirm onUnmount={this.fixBody}
              open={this.state.openConfirmPopup}
              onCancel={this.handleCancel}
              onConfirm={this.handleConfirm}
              cancelButton={lang.no}
              confirmButton={lang.yes}
              content= {lang.exit_confirm}
              className='mini direct-apply-cancel'
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appliedEmi: state.appliedAutoLoanEmi,
  applyInputForm: state.applyInputForm,
  activeLanguage: state.activeLanguage,
});

const mapDispatchToProps = {
  applySuccess,
  storeSimulateEmail,
  storeApplyFormInput,
};

const CardCompareContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CardCompare));

export default CardCompareContainer;



// WEBPACK FOOTER //
// ./src/components/autoLoans/CardCompare.js